import { ConfigState, CoreComponentConfig, EmpathyXConfig } from '../../../models';
import { CONFIG_GETTERS_KEYS } from '../config.const';
import { ConfigGetter } from '../config.interfaces';

export class CoreComponentsGetter implements ConfigGetter {
  getters = {
    [CONFIG_GETTERS_KEYS.coreComponents]: (configState: ConfigState, getters: any): CoreComponentConfig[] => {
      const config: EmpathyXConfig = getters[CONFIG_GETTERS_KEYS.config];
      return Object.values<CoreComponentConfig>(config.core.components)
        .filter(componentConfig => !!componentConfig)
        .sort((aConfig, bConfig) => (aConfig.order ?? 0) - (bConfig.order ?? 0))
        .map(coreComponentConfig => {
          return coreComponentConfig;
        });
    }
  };
}
